export default __webpack_public_path__ + "static/media/payment_method.af929afd.png";